export default __webpack_public_path__ + "static/media/glaPostcard.a9fbdec7.jpg";